export const SET_LOADING_DATA = '@salesTracking/SET_LOADING_DATA';
export const SET_LOADING_RECOMMENDATION = '@salesTracking/SET_LOADING_RECOMMENDATION';

export const GET_ALL_REQUEST = '@salesTracking/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@salesTracking/GET_ALL_SUCCESS';

export const GET_RECOMMENDATION_REQUEST = '@salesTracking/GET_RECOMMENDATION_REQUEST';
export const GET_RECOMMENDATION_SUCCESS = '@salesTracking/GET_RECOMMENDATION_SUCCESS';
